<template>
	<div id="app">

        <div class="card border-primary" style="margin-bottom:20px;">
			<div class="card-header">
				<h5 style="margin-bottom:0px;">BetRadar NBA Series</h5>
			</div>
			<div class="card-body">
				<div class="form-row">
					<div class="col">
						<div class="form-group">
							<label>Year</label>
							<select @change="selectYear" class="form-control">
								<option value="">-- Select --</option>
								<option value="2017">2017</option>
                                <option value="2018">2018</option>
                                <option value="2019" selected>2019</option>
                                <option value="2020">2020</option>
							</select>
						</div>
					</div>
                    <div class="col">
						<div class="form-group">
							<label>Season</label>
							<select @change="selectSeason" class="form-control">
								<option value="">-- Select --</option>
								<option value="PRE">PRE - Pre-season</option>
                                <option value="REG">REG - Regular season</option>
                                <option value="PST" selected>PST - Past season</option>
							</select>
						</div>
					</div>
                    <div class="col">
						<div class="form-group" v-if="series">
							<label>Series</label>
							<select @change="selectSportEvent" class="form-control">
								<option value="">-- Select --</option>
                                <option v-for="series in series"  v-if="series" :value="series.id">
                                    {{ series.start_date }} - {{ series.status }} - {{ series.title }}
                                </option>
							</select>
						</div>
					</div>
				</div>
				
				<div>
					<p>These are the BetRadar endpoints used to build this page.</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Series Schedule</td>
							<td>
                                <a :href="getSeriesScheduleEndpoint(true)" target="_blank">{{ getSeriesScheduleEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr v-if="getSeriesStatisticsEndpoint(this.home)">
                            <td>Series Statistics Home Team</td>
							<td>
                                <a :href="getSeriesStatisticsEndpoint(this.home, true)" target="_blank">{{ getSeriesStatisticsEndpoint(this.home, true) }}</a>
                            </td>
                        </tr>
                        <tr v-if="getSeriesStatisticsEndpoint(this.away)">
                            <td>Series Statistics Home Team</td>
							<td>
                                <a :href="getSeriesStatisticsEndpoint(this.away, true)" target="_blank">{{ getSeriesStatisticsEndpoint(this.away, true) }}</a>
                            </td>
                        </tr>
					</table>
				</div>
				
			</div>
		</div>

        <div v-if="seriesId">
            <div id="accordion">
                <div class="card">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game" aria-expanded="true" aria-controls="collapseOne">
							Games and Partecipants
							</button>
						</h5>
					</div>
					<div id="game" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>{{ selected_series.title }}</h3>

                            <h4>participants</h4>

                            <table class="table">
                                <tr>
                                    <th>name</th>
                                    <th>market</th>
                                    <th>seed</th>
                                    <th>record</th>
                                    <th>source</th>
                                </tr>
                                <tr v-for="participant in selected_series.participants">
                                    <td>{{ participant.name }}</td>
                                    <td v-if="participant.team">{{ participant.team.market }}</td>
                                    <td>{{ participant.seed }}</td>
                                    <td>{{ participant.record }}</td>
                                    <td v-if="participant.source">
                                        title: {{ participant.source.title }}<br>
                                        round: {{ participant.source.round }}<br>
                                        outcome: {{ participant.source.outcome }}<br>
                                    </td>
                                </tr>
                            </table>

                            <div v-if="selected_series.games!=[]">
                                <h4>games</h4>

                                <table class="table">
                                    <tr>
                                        <th>id</th>
                                        <th>status</th>
                                        <th>title</th>
                                        <th>coverage</th>
                                        <th>scheduled</th>
                                        <th>home_points</th>
                                        <th>away_points</th>
                                        <th>neutral_site</th>
                                        <th>track_on_court</th>
                                        <th>sr_id</th>
                                    </tr>
                                    <tr v-for="game in selected_series.games">
                                        <td>{{ game.id }}</td>
                                        <td>{{ game.status }}</td>
                                        <td>{{ game.title }}</td>
                                        <td>{{ game.coverage }}</td>
                                        <td>{{ game.scheduled }}</td>
                                        <td>{{ game.home_points }}</td>
                                        <td>{{ game.away_points }}</td>
                                        <td>{{ game.neutral_site }}</td>
                                        <td>{{ game.track_on_court }}</td>
                                        <td>{{ game.sr_id }}</td>
                                    </tr>
                                </table>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="series_statistics_home != [] && series_statistics_away != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#seasonal-statistics" aria-expanded="true" aria-controls="collapseOne">
							Series Statistics
							</button>
						</h5>
					</div>

					<div id="seasonal-statistics" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
							
                            <h3>home_team</h3>

                            <div v-if="series_statistics_home">
                                <NBASeasonalStatistics
                                    :statistics="series_statistics_home"
                                ></NBASeasonalStatistics>
                            </div>
                            

                            <h3>away_team</h3>

                            <div v-if="series_statistics_away">
                                <NBASeasonalStatistics
                                    :statistics="series_statistics_away"
                                ></NBASeasonalStatistics>
                            </div>
                                            
						</div>
					</div>
				</div>

            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'
import NBASeasonalStatistics from './components/NBASeasonalStatistics.vue'

export default {
    name: 'app',
    components: {
        NBASeasonalStatistics,
	},
    created: function() {

        this.loadSchedule();
    
    },
    data: function() {
        return {            
            apiKey: 'c35guurt2ystkshn7szzxhp8',
            year: 2019,
            season: "PST",
            schedule: [],
            play_by_play: [],
            seriesId: '',
            series: [],
            selected_series: '',
            sportEventId: '',
            sport_event: '',
            home: '',
            away: '',
            game_boxscore: [],
            game_summary: [],
            injuries: [],
            series_statistics_home: '',
            series_statistics_away: '',
        }
    }, 
    methods: {
        getSeriesScheduleEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/series/${this.year}/${this.season}/schedule.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getSeriesStatisticsEndpoint: function(team, showBetradarUrl = false) {

            if(team == '' || !team) return '';

            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/series/${this.seriesId}/teams/${team.id}/statistics.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        loadSchedule: function() {

            // get full list of tournaments
            axios.get(this.getSeriesScheduleEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('series', response.data);

                this.series = response.data.series;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadSeriesStatistics: function() {

            if(this.getSeriesStatisticsEndpoint(this.home) == ''
                || this.getSeriesStatisticsEndpoint(this.away) == ''
            ) return;

            axios.get(this.getSeriesStatisticsEndpoint(this.home), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('series_statistics_home', response.data);
            
                this.series_statistics_home = response.data;
            
            }, (error) => {
                console.log(error)
            });

            axios.get(this.getSeriesStatisticsEndpoint(this.away), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('series_statistics_away', response.data);

                this.series_statistics_away = response.data;
            
            }, (error) => {
                console.log(error)
            });
        },

        getSportEventName: function(sport_event) {

            let name = sport_event.home.name + ' vs ' + sport_event.away.name;

            return name;
        },

        selectYear: function(event) {
			
			this.year = event.target.value;
			this.loadSchedule();
        },

        selectSeason: function(event) {
			
			this.season = event.target.value;
			this.loadSchedule();
        },

        selectSportEvent: function(event) {
			  
            let seriesId = event.target.value;
            let selected_series = '';

            let temp_selected_series = this.series.find(function(series) {
                    return series.id == seriesId;
                });
            
            if(temp_selected_series) {
                selected_series = temp_selected_series;
            }

            this.seriesId = event.target.value;
            this.selected_series = selected_series;
            this.home = selected_series.participants[0].team;
            this.away = selected_series.participants[1].team;

            this.loadSeriesStatistics();
        },
    },
}
</script>